export function parseInteger(str) {
    if (!/^[+-]?\d+$/.test(str.trim())) {
        return undefined;
    }
    const n = parseInt(str);
    if (isNaN(n)) {
        return undefined;
    }
    return n;
}
